<template>
  <div id="coordinator-trainers">
    <b-container id="coordinator-trainers-table" fluid>
      <b-row class="mt-4">
        <b-col cols="5">
          <br />
          <b-col>
            <h4 class="subtitle">
              Coordinator's Current Trainers ({{ trainersTable.length }})
            </h4>
            <b-form-group>
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-table
              v-cloak
              responsive
              :fields="coordinatorTrainersFields"
              :items="trainersTable"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              small
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered"
            >
              <template slot="cell(name)" slot-scope="row" v-if="trainersTable">
                <b-link
                  @click.stop="stopClick"
                  :to="{
                    name: 'EditTrainer',
                    params: { id: row.item.trainer_uuid },
                  }"
                  >{{ row.item.name }}</b-link
                >
              </template>
              <template slot="cell(active)" slot-scope="row">
                <b-form-radio-group
                  :id="row.item.trainer_uuid"
                  :value="row.item.active"
                  v-model="row.item.active"
                  @change="updateCoordinatorTrainer(row)"
                >
                  <b-form-radio :value="true">True</b-form-radio>
                  <b-form-radio :value="false">False</b-form-radio>
                </b-form-radio-group>
              </template>
              <template slot="cell(delete)" slot-scope="row">
                <b-link
                  class="delete"
                  @click.stop="deleteCoordinatorTrainer(row.item)"
                  >Delete Link</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="my-1">
                <b-pagination
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CoordinatorService from "../services/CoordinatorService";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "CoordinatorTrainers",
  mixins: [flash, scrollTo],
  data() {
    return {
      coordinatorId: this.$route.params.id ? this.$route.params.id : null,
      isDisabled: true,
      country: "",
      region: "",
      district: "",
      village: "",
      coordinatorTrainersFields: [
        { key: "name", label: "Name", sortable: true },
        { key: "active", label: "Active?", sortable: true },
        { key: "delete", label: "DELETE" },
      ],
      file: this.$route.path.slice(1),
      currentPage: 1,
      country: "",
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: null,
      filterSearchResults: null,
      totalRows: this.rows,
    };
  },
  methods: {
    ...mapActions({
      GET_COORDINATOR_TRAINERS: "coordinators/GET_COORDINATOR_TRAINERS",
      RESET_COORDINATORS_STATE: "coordinators/RESET_COORDINATORS_STATE",
      RESET_SEARCH: "searches/RESET_SEARCH_STATE",
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredResults(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async updateCoordinatorTrainer(params) {
      const payload = await {
        id: params.item.id,
        trainer_id: params.item.trainer_id,
        trainer_uuid: params.item.trainer_uuid,
        coordinator_uuid: this.$route.params.id,
        active: !params.item.active,
      };
      await CoordinatorService.updateCoordinatorTrainer(payload);
      await this.GET_COORDINATOR_TRAINERS();
    },
    async addTrainerToCoordinator(params) {
      const payload = await {
        trainer_id: params.item.trainer_id,
        trainer_uuid: params.item.trainer_uuid,
        coordinator_uuid: this.$route.params.id,
        active: true,
      };
      await CoordinatorService.addCoordinatorTrainer(payload);
      await this.scrollTo("coordinator-trainers-alert");
      await this.flashSuccess();
      await this.GET_COORDINATOR_TRAINERS();
    },
    async deleteCoordinatorTrainer(params) {
      const confirmDelete = confirm(
        "Are you sure you want to remove this school from this coordinator?"
      );
      if (confirmDelete) {
        await CoordinatorService.deleteCoordinatorTrainer(params);
        await this.GET_COORDINATOR_TRAINERS();
      }
    },
    stopClick(row) {},
  },
  computed: {
    trainers: {
      get() {
        // add some stuff to clean this up
        return this.$store.state.coordinators.coordinatorTrainers;
      },
    },
    trainersTable() {
      const trainers = this.trainers.map((k) => ({
        trainer_id: k.id,
        trainer_uuid: k.uuid,
        name: `${k.first_name} ${k.middle_name} ${k.last_name}`,
        active: k.active,
      }));
      return trainers;
    },
    rows() {
      return this.trainers.length;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.coordinatorTrainersFields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.GET_COORDINATOR_TRAINERS();
  },
};
</script>

<style scoped>
.add {
  color: green;
  font-weight: bold;
}
.small-date {
  font-style: italic;
  font-size: 10px;
  color: #5a6269;
}
table th,
table tr {
  text-align: center;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.delete {
  color: #9f020f;
  font-weight: bold;
}
</style>
